﻿import $ from "jquery";

export class SedCards {

    init(): void {
        $(".modal-button").click((evt) => {
            const button: JQuery = $(evt.currentTarget);
            var targetId = button.data("target");
            var dialog = $(targetId);
            /*$("html").addClass("is-clipped");*/
            dialog.addClass("is-active");
        });

        $(".modal-close").click((evt) => {
            const button: JQuery = $(evt.currentTarget);
            button.parent().removeClass("is-active");
        });
    }
}